module.exports = __webpack_public_path__ + "static/media/QAtest.3d4db4ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/QAtest.jpg
// module id = 389
// module chunks = 0